import React, { useEffect, useState } from 'react';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import EditPopup from '../../components/Popup/EditPopup/EditPopup'; 
import AddPopup from '../../components/Popup/AddPopup/AddPopup';
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import DeletePopup from '../../components/Popup/DeletePopup/DeletePopup';
import EditIcon from '../../components/Table/EditIcon/EditIcon';
import DeleteIcon from '../../components/Table/DeleteIcon/DeleteIcon';
import ArchiveIcon from '../../components/Table/ArchiveIcon/ArchiveIcon';
import ExportLabel from '../../components/common/ExportLabel/Export';
import AddButton from '../../components/common/AddButton/AddButton';
import Filter from '../../components/common/Filter/Filter';
import Sort from '../../components/common/Sort/Sort';
import '../../components/common/SubNavbar.css';
import '../../components/common/CommonText.css';
import SimpleSearchBox from '../../components/common/Search/SimpleSearch';
import { baseurl } from '../../api';
import { isRequired, isTextOnly } from '../../validation';
import { useCheckboxClick } from '../../checkboxclick';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import authenticatedAxios from '../../authenticatedAxios';
import useFilterStore from '../../store/useFilterStore';
import { useNavigate } from 'react-router-dom';
import useRefreshStore from '../../store/useRefreshStore';
const pageKey = "faqcategory"

const FaqCategories = () => {
  const { setFilters, getFilters } = useFilterStore();
  const savedFilters = getFilters(pageKey);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState([]);
  const [items, setItems] = useState([]);
  const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
  const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "Unarchived");
  const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest");
  const navigate = useNavigate();
  const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(items);
  const sortOptions = ['A-Z', 'Z-A', 'Newest', 'Oldest'];
  const filterOptions = ['Default', 'Archived', 'Unarchived'];
  const [popupError, setPopupError] = useState('');
  const { refreshKeys } = useRefreshStore();
  const refreshKey = refreshKeys["FAQ Categories"] || 0;




  const fetchCategories = async (id = null) => {
    try {
      if (id) {
        const response = await authenticatedAxios.get(`${baseurl}faq/category/?id=${id}`);
        if (response && response.data) {
          setSelectedItem(response.data.data); 
          setIsEditPopupOpen(true); 
        } else {
          console.error("No data found for the selected category.");
        }
      } else {
        const params = {
          search: searchParams.term,
          filter: selectedFilterOption === 'Default' ? undefined : selectedFilterOption.toLowerCase(),
          sort: mapSortOptionToQuery(selectedSortOption), 
        };
  
        const response = await authenticatedAxios.get(`${baseurl}faq/category/`, { params });
        if (response.data.response_code === 1) {
          setItems(response.data.data);
        }
      }
    } catch (error) {
      if (error?.response?.data?.error_code === 1001) {
        navigate("/permission-denied");
      } else {
        console.error('Error fetching categories:', error);
      }
    }
  };
  
  
  
  useEffect(() => {
    fetchCategories();
    setFilters(pageKey, {
      searchParams,
      selectedFilterOption,
      selectedSortOption,
  });
  }, [searchParams, selectedFilterOption, selectedSortOption]); 

  useEffect(() => {
    fetchCategories();
  }, [refreshKey]);

  const handleAddCategory = async (formValues) => {
    try {
      const response = await authenticatedAxios.post(
        `${baseurl}faq/category/`,
        formValues
      );
  
      if (response.data.response_code === 1) {
        await fetchCategories();
        closePopups();
      } else {
        setPopupError(response.data.message || 'Something went wrong!');
      }
    } catch (error) {
      setPopupError('Failed to add category. Please try again.');
    }
  };
  
  const handleEditCategory = async (formValues) => {
    try {
      const response = await authenticatedAxios.put(
        `${baseurl}faq/category/?id=${selectedItem.id}`,
        formValues
      );
  
      if (response.data.response_code === 1) {
        await fetchCategories();
        closePopups();
      } else {
        setPopupError(response.data.message || 'Something went wrong!');
      }
    } catch (error) {
      setPopupError('Failed to update category. Please try again.');
    }
  };
  


  const handleArchiveSelectedItems = async () => {
    try {
      const response = await authenticatedAxios.post(`${baseurl}faq/category/archive/`, {
        id_list: selectedItems,
      });

      if (response.status >= 200 && response.status < 300) {
        fetchCategories();
        resetCheckboxState();
        closePopups();
      } 
    } catch (error) {
      
    }
  };

  const handleArchive = async () => {
    try {
        const response = await authenticatedAxios.get(
            `${baseurl}faq/category/archive/?id=${selectedItem.id}`
        );

        if (response.status >= 200 && response.status < 300) {
            await fetchCategories(); 
            closePopups();
        } 
    } catch (error) {
        console.error('Error archiving category:', error);
    }
  };

  const handleDelete = async () => {
    try {
        const response = await authenticatedAxios.delete(
            `${baseurl}faq/category/?id=${selectedItem.id}`
        );

        if (response.status >= 200 && response.status < 300) {
            await fetchCategories(); 
            closePopups(); 
        } else {
            console.error('Failed to delete state.');
        }
    } catch (error) {
        console.error('Error deleting state:', error);
    }
};


  const mapSortOptionToQuery = (option) => {
    switch (option) {
      case 'A-Z':
        return 'a_to_z';
      case 'Z-A':
        return 'z_to_a';
      case 'Newest':
        return 'newest';
      case 'Oldest':
        return 'oldest';
      default:
        return 'newest';
    }
  };

  const handleSortOptionSelect = (option) => {
    setSelectedSortOption(option);
  };

  const handleFilterSelect = (option) => {
    setSelectedFilterOption(option);
  };

  const handleSearchSelect = (searchTerm) => {
    setSearchParams({ term: searchTerm });
  };


  const handleEditClick = (item) => {
    fetchCategories(item.id); 
  };
  
  const handleArchiveClick = async (item) => {
    setSelectedItem(item);
    setIsArchivePopupOpen(true);
  };


  const handleNewClick = () => {
    setSelectedItem(null);
    setIsNewPopupOpen(true);
  };

  const handleDeleteClick = (item) => {
    setSelectedItem(item); 
    setIsDeletePopupOpen(true); 
  };

  const closePopups = () => {
    setIsEditPopupOpen(false);
    setIsArchivePopupOpen(false);
    setIsNewPopupOpen(false);
    setIsDeletePopupOpen(false);
    setSelectedItem(null);
    setPopupError('');
  };

  const addPopupFields = [
    { label: 'Category Name', 'name':'name',type: 'large-input', defaultValue: '', onChange: () => {}, validators:[isTextOnly,isRequired] }
  ];

  const deletePopupFields = [
    { label: 'Are you sure you want to delete this record? Once deleted, the data will be permanently removed.', type: 'text' },
  ];

  const editPopupFields = [
    { label: 'Category Name', 'name':'name', type: 'large-input', defaultValue: selectedItem?.name,validators:[isTextOnly,isRequired], onChange: () => {} }
  ];


  const handleExportComplete = () => {
    resetCheckboxState();
  };


  return (
    <div className='whole-container'>
      <div className='top-heading'>
        <PageHeader pageName=" FAQ /" nestedpageName="FAQ Categories"  linkTo="/faqs" /> 
        
        <div className='export-container'>
        <ArchiveSelectedItem
          selectedItems={selectedItems}
          items={items}
          onArchiveSelected={handleArchiveSelectedItems}
        />
          <ExportLabel
            exportUrl={`${baseurl}faq/category/export/`}
            selectedIds={selectedItems}
            onExportComplete={handleExportComplete}
          />
        </div>
      </div>
      <div className='pagename-container'>
        <div className='page-name'>
          <h1 className='common-text fts-22 ftw-6 blue'>FAQ Categories</h1>
        </div>
        <div className='pagename-right-container'>
          <AddButton onClick={handleNewClick} />
          <SimpleSearchBox placeholder="Search FAQ Categories" onSearchSelect={handleSearchSelect} defaultValue={searchParams?.term}/>
          <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption}/>
          <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect} defaultValue={selectedSortOption} />
        </div>
      </div>
      <div className='table-container'>
        <table className='common-table'>
          <thead className='common-table-head'>
            <tr className='common-table-thead-tr'>
              <th>
                  <input
                    className="table-selectbox table-parent-selectbox"
                    type="checkbox"
                    checked={isParentSelected}
                    onChange={handleParentCheckboxChange}
                  />Category
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody className='common-table-tbody'>
          {items.length > 0 ? (
            items.map((category) => (
              <tr key={category.id} className={category.is_archived ? 'archived-item' : ''}>
                <td>
                  <input
                    className="table-selectbox table-child-selectbox"
                    type="checkbox"
                    checked={selectedItems.includes(category.id)}
                    onChange={() => handleChildCheckboxChange(category.id)}
                  />{category.name}
                </td>
                <td className="actions common-action">
                  <EditIcon onClick={() => handleEditClick(category)} />
                  <ArchiveIcon onClick={() => handleArchiveClick(category)}  isArchived={category.is_archived} />
                  <DeleteIcon onClick={() => handleDeleteClick(category)} />
                </td>
              </tr>
            ))
          ):(
            <tr>
              <td colSpan="3">No Category Available</td>
            </tr>
          )}
          </tbody>
        </table>
      </div>

      <EditPopup 
        isOpen={isEditPopupOpen}
        title="FAQ Category"
        fields={editPopupFields}
        onSave={handleEditCategory}
        onClose={closePopups}
        popupErrorMessage={popupError}
      />
      <ArchivePopup
        isOpen={isArchivePopupOpen}
        isArchived={selectedItem?.is_archived}
        archivename={selectedItem?.name}
        onSave={handleArchive}
        onClose={() => setIsArchivePopupOpen(false)}
      />


      <DeletePopup 
        isOpen={isDeletePopupOpen}
        title="Delete Category"
        fields={deletePopupFields}
        onSave={handleDelete}
        onClose={closePopups}
      />
      <AddPopup 
        isOpen={isNewPopupOpen}
        title="New FAQ Category"
        buttonName='Add FAQ Category'
        fields={addPopupFields}
        onSave={handleAddCategory}
        onClose={closePopups}
        popupErrorMessage={popupError}
      />
    </div>
  );
};

export default FaqCategories;
